import React, { PropsWithChildren } from "react";

const PublicLayout: React.FC<PropsWithChildren> = ({ children }) => {
    return (
        <div className="w-screen p-5 flex flex-col items-center justify-center gap-8">

            <div
                className={`bg-base-100 p-5 xl:p-10 rounded-lg shadow-2xl border border-line w-full lg:w-5/6 mx-auto`}
            >
                {children}
            </div>
        </div>
    );
};

export default PublicLayout;
